export const ApiEndpoints = {
  AUTHENTICATION: {
    LOGIN: `/authenticate`,
    REFRESH_TOKEN: `/authenticate/refresh_token`,
    REGISTER: `/authenticate/register`,
    NEW_PASSWORD: `/authenticate/new-password`,
    FORGOT_PASSWORD: `/authenticate/forgot-password`,
    VERIFY: `/authenticate/verify-user`,
    RESEND_VERIFY: `/authenticate/resend-verify-mail`,
    VERIFY_2FA: `/authenticate/verify-2fa`,
    RESEND_2FA: `/authenticate/resend-2fa`,
    GOOGLE: `/authenticate/google`
  },

  ACCOUNT: {
    INVOICE: 'account_invoice',
    FACILITY: '/facility',
    INVOICE_CHECKOUT: '/account_invoice',
    PAYMENT: 'account_payment',
    QBO: 'qbo',
    FINANCE_FEE: 'finance_fee',
    INVOICE_LINE: 'account_invoice_line',
    TAX: 'account_tax',
    JOURNAL: 'account_journal',
    SALE_ORDER: 'sale_order',
    SALE_ORDER_LINE: 'sale_order_line',
    PRODUCT: 'product_product',
    DISCOUNT: 'account_discount',
    READ_LATE_BILLING: 'read_late_billing',
    READ_TERMINATIONS: 'read_terminations',
    READ_INVOICING: 'read_invoicing',
    READ_REVENUE: 'revenue',
    CLASS: 'account_class',
    CHAT: 'chat'
  },

  RES: {
    PERMISSION: 'res_permission',
    MODULE: 'res_module',
    PARTNER_TYPE: 'res_partner_type',
    COMPANY: 'res_company',
    PARTNER: 'res_partner',
    GROUP: 'res_group',
    USER: 'res_user',
    COUNTRY: 'res_country',
    STATE: 'res_state',
    CITY: 'res_city',
    ATTACHMENT: 'res_attachment',
    FACILITY: 'res_partner_facility',
    FACILITY_DISCOUNT: 'facility_discount',
    FACILITY_CLASS: 'res_partner_facility_class',
    EMPLOYEE: 'res_employee',
    EMPLOYEE_SPECIALIZATION: 'res_employee_specialization',
    SPECIALTY: 'res_partner_specialty',
    SPOKEN_LANGUAGE: 'spoken_language',
    PLAN_OF_CORRECTION: 'plan_of_correction',
    UPDATE_PASSWORD: `res_user`,
    CERTIFYING_BOARD: 'certifying_board',
    MEMBER_BOARD: 'member_board'
  },

  FILE: {
    FILE: 'file'
  },

  PRODUCT: {
    PRODUCT: 'product_product',
    UOM: 'product_uom'
  },

  ACCR: {
    APPLICATION: 'accr_application',
    TYPE: 'accr_type',
    SUBTYPE: 'accr_sub_type',
    SPECIALIST_DETAILS: 'accr_application_specialist',
    CLINICAL_DETAILS: 'accr_application_clinical',
    ACCREDITATION: 'accr',
    ACCREDITATION_CYCLE: 'accr_cycle',
    ACCREDITATION_CERTIFICATE: 'accr_cert',
    PIONEER_PROGRAM: 'pioneer_program'
  },

  SURVEY: {
    SURVEY: 'survey',
    ANSWER: 'survey_answer',
    OPTION: 'survey_option',
    DEFICIENCY: 'deficiencies',
    STATEMENT_OF_DEFICIENCY: 'statement_of_deficiency',
    SURVEYOR: 'surveyor',
    SURVEYORS: 'surveyors',
    SURVEYORS_MANAGEMENT: 'surveyors_management',
    SURVEYORS_AVAILABILITY: 'surveyor_availability',
    QUESTION: 'survey_question',
    ATTRIBUTE: 'survey_attribute',
    ASSIGNMENT: 'assignment',
    STANDARD_MANAGEMENT: 'standards_management',
    FOLLOW_UP: 'generate_follow_up',
    WORKSHEET: 'survey_worksheet'
  },

  MEDSPA: {
    PROCEDURE: 'medspa_procedure'
  },

  NOTE: {
    NOTE: 'check_item_note'
  },

  INVESTIGATION: {
    INVESTIGATION: 'investigation'
  },

  REPORTS: {
    EXTERNAL_REPORTS: 'external-reports',
    WASHINGTON_REPORT: 'washington-report',
    SOUTH_CAROLINA_REPORT: 'south-carolina-report',
    NEW_YORK_REPORT: 'new-york-report',
    CMS_MONTHLY_REPORT: 'cms-monthly-report',
    CMS_WEEKLY_REPORT: 'cms-weekly-report',
    CMS_CUSTOM_REPORT: 'cms-custom-report',
    CMS_FORECAST_REPORT: 'cms-forecast-report',
    ASSURE_REPORT: 'assure-report',
    AGING_REPORT: 'aging-report',
    COMPLETE_SURVEY_REPORT: 'complete-report',
    DEFICIENCY_REPORT: 'deficiencies-program-report',
    DEFICIENCY_QUESTION_REPORT: 'deficiencies-question-report',
    REACTIVATED_SURVEYS_REPORT: 'reactivated-surveys-report',
    ONSITE_TIME_IN_OUT_REPORT: 'onsite-time-in-out-report',
    FACILITY_COUNTS_REPORT: 'facility-counts-report'
  },

  HISTORY: {
    HISTORY: 'history'
  },

  FACILITY_INFO: {
    APPROVAL_REQUEST: 'approval_request',
    EXTENSION_SITE: 'extension_site',
    NATIONAL_ACCOUNT: 'national_account'
  },

  ASSIGNMENT: {
    ASSIGNMENT: 'assignment'
  },
  NOTIFICATION: {
    NOTIFICATION: 'notification',
    NOTIFICATION_LIST: 'notifications_list',
    TOKEN: 'token'
  },

  PROFILE: {
    UPDATE_TWO_FACTOR: 'profile/update/two-factor',
    VERIFY_TWO_FACTOR: 'profile/verify/two-factor'
  }
};

export const Actions = {
  BASE_ACTIONS: {
    CREATE: 'create',
    READ: 'read',
    READ_PARTIAL: 'read_partial',
    READ_CUSTOM: 'read/custom',
    READALL: 'read?readAll=true',
    UPDATE: 'update',
    UPDATE_PARTIAL: 'update_partial',
    DELETE: 'delete',
    FETCH: 'fetch',
    PRINT: 'print',
    EXPORT: 'export',
    VALID: 'valid',
    MERGE: 'merge',
    CREATE_SURVEY: 'create_survey',
    READ_PROGRAM: 'program'
  },
  FACILITY: {
    LICENSE_EXISTS: 'license_exists',
  },

  APPROVAL_REQUEST: {
    ADMIN_READ: 'admin_read',
    FACILITY_READ: 'facility_read'
  },

  NATIONAL_ACCOUNT: {
    READ: 'read',
    FACILITY_READ: 'facility:read',
    CREATE: 'create'
  },

  EMPLOYEE: {
    LICENSE_EXISTS: 'license_exists',
    READ_BY_LICENSE: 'read_by_license'
  },

  ACCR: {
    PRINT: 'read/print'
  },

  ACCR_APPLICATION: {
    ASSIGN_SPECIALIST: 'assign_specialist',
    ASSIGN_CLINICAL_REVIEWER: 'assign_clinical_reviewer',
    ADDITIONAL_SERVICES: 'additional_services',
    APPLY: 'apply',
    CREATE_REQUEST: 'create_request',
    UPDATE_REQUEST: 'update_request'
  },

  ACCREDITATION: {
    CUSTOM_READ: 'custom_read',
  },

  USER: {
    READ_SPECIALISTS: 'read_specialists',
    READ_SPECIALISTS_BY_PROGRAM_ID: (programId: number) => {
      if (programId != null) {
        return `read/by_program/${programId}`;
      }
    },
    CUSTOM_READ_USER_CREATE: 'read/user_create'
  },

  INVOICE: {
    FACILITY_READ_FEE: 'read_facility',
    PRINT: 'read/print'
  },

  PAYMENT: {
    VALIDATE: 'validate',
    REFUND: 'refund',
    PRINT: 'read/print'
  },

  RES: {
    PRINT: 'read/print'
  },

  SALE_ORDER: {
    PRINT: 'read/print'
  },

  SURVEY: {
    PRINT: 'read/print',
    ASSIGN: 'update/assign',
    SET_DATE: 'update/date'
  },

  ASSIGNMENT: {
    READ_BY_FACILITY: 'read_by_facility',
    READ_OWNERSHIP: 'read_ownership',
    READ_OWNER: 'read_owner',
    UPDATE_SPECIALIST_END_DATE: 'update/specialist/end-date'
  },

  APPLICATION: {
    READ_BY_FACILITY_ID: (facilityId: number) => {
      if (facilityId != null) {
        return `read/by_facility/${facilityId}`;
      }
    },
  }
};

export const Applications = {
  APP: 'Portal',
};
